import { render } from "./CSection.vue?vue&type=template&id=539e5cca"
import script from "./CSection.vue?vue&type=script&lang=js"
export * from "./CSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/work_projects/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__